import { IFlow } from '_/features/flows/common/types/flow.types';
import { IFlowSettingsPageAdapterParams } from '_/features/flowSettings/flowSettings.adapter.types';
import { IFlowSettingsPageItem } from '_/features/flowSettings/flowSettings.types';

const flowSettingsUrlAdapter = (orgSlug: string, flow: IFlow) => {
  const { project, slug: flowSlug } = flow || {};
  const projectSlug = project?.slug;
  const projectUrl = `/orgs/${orgSlug}/projects/${projectSlug}`;
  const flowSettingsUrl = `${projectUrl}/flows/${flowSlug}/settings`;
  return {
    flowSettingsUrl: flowSettingsUrl,
    projectUrl: projectUrl,
  };
};

export const flowSettingsPageItemsAdapter = ({
  flow,
  flowSegments,
  orgSlug,
}: IFlowSettingsPageAdapterParams): IFlowSettingsPageItem[] => {
  const isChainedFlow = !!flow.definition?.chains;
  const { flowSettingsUrl, projectUrl } = flowSettingsUrlAdapter(orgSlug, flow);

  return flowSegments.map((item, index) => {
    const { id, collection } = item;
    const { name = '', slug = '' } = collection || {};
    const defaultSettingsHref = `${projectUrl}/collections/${slug}/settings`;
    const settingsHref = `${flowSettingsUrl}/${id}/settings`;

    return {
      ...item,
      defaultSettingsHref: defaultSettingsHref,
      header: isChainedFlow ? `Segment ${index + 1}: ${name}` : name,
      settingsHref: settingsHref,
    };
  });
};
